//@ts-check
import { useCallback } from "react";
import { toastAlert } from "../../../components/Toastify";
import {
  handleRemoveRdm,
  handleRemoveRdmUser,
  handleUpdateRdm,
} from "../../../state/rdms/actions";

/**
 * @param {string | undefined} id
 * @param {() => void} onClose
 * @param {() => void} redirect
 * @returns {{
 *  onDelete: () => Promise<void>
 *  onUpdate: (title: string, description: string) => Promise<any>
 *  onDeleteUser: (rdmUserId: string) => Promise<void>
 * }}
 */
export function useActions(id, onClose, redirect) {
  const onDelete = useCallback(async () => {
    if (!id) return;
    try {
      await handleRemoveRdm(id);
      redirect();
    } catch (error) {
      toastAlert({
        msg: `Ocorreu um Erro ao remover o Rdm.`,
        isError: true,
      });
      console.log(error);
    } finally {
      onClose();
    }
  }, [id, onClose, redirect]);

  const onDeleteUser = useCallback(
    async (rdmUserId) => {
      if (rdmUserId) return;
      try {
        await handleRemoveRdmUser(rdmUserId);
        toastAlert({
          msg: `Usuário removido com sucesso.`,
        });
      } catch (error) {
        toastAlert({
          msg: `Ocorreu um Erro ao remover o Usuário.`,
          isError: true,
        });
        console.log(error);
      } finally {
        onClose();
      }
    },
    [onClose]
  );

  const onUpdate = useCallback(
    async (title, description) => {
      if (!id) return;
      try {
        const res = handleUpdateRdm(id, { title, description });
        toastAlert({
          msg: `Rdm atualizado com sucesso.`,
        });
        return res;
      } catch (error) {
        toastAlert({
          msg: `Ocorreu um Erro ao atualizar o Rdm.`,
          isError: true,
        });
        console.log(error);
      }
    },
    [id]
  );

  return { onDelete, onDeleteUser, onUpdate };
}
